module.exports = __webpack_public_path__ + "media/images/icon_photo01_on_18-15-c17c72fb5781941dd5e57399718033fe.png";